




import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  ModelEditableMixin,
} from "../../../system/mixins";
import { PatientProfileDialogsAccessor } from "../CommonComponentsAccessor";

@Component
export default class PatientProfileEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  dialogs: PatientProfileDialogsAccessor;

  edit(): void {
    const patientId = this.editingSource.attributes.patient.id;
    const source = this.editingSource.patientProfile.clone();
    this.dialogs.editor.show(patientId, source)
    .then((info) => {
      if (!info) { return; }
      this.writeProperty(s => s.patientProfile = info);
    }).catch(e => {
      this.$error("エラー", "患者プロフィールの処理中にエラーが発生しました。", e);
    });
  }
}
